import React, { useEffect, useState } from 'react';
import { getOpeningHoursRange } from '../lib/api';

let hoursRequest = null;

export function resetOpeningHoursCacheForTests() {
  hoursRequest = null;
}

const isoDate = (date) => date.toISOString().slice(0, 10);

function upcomingRange() {
  const start = new Date();
  start.setHours(12, 0, 0, 0);
  const end = new Date(start);
  end.setDate(end.getDate() + 13);
  return [isoDate(start), isoDate(end)];
}

function loadHours() {
  if (!hoursRequest) {
    const [start, end] = upcomingRange();
    hoursRequest = Promise.resolve(getOpeningHoursRange(start, end))
      .then(({ data, error } = {}) => (error || !Array.isArray(data) ? [] : data))
      .catch(() => []);
  }
  return hoursRequest;
}

function formatDate(value) {
  const date = new Date(`${value}T12:00:00`);
  if (Number.isNaN(date.getTime())) return '';
  return new Intl.DateTimeFormat('sv-SE', {
    weekday: 'short', day: 'numeric', month: 'long',
  }).format(date).replace('.', '');
}

function formatTime(value) {
  return value ? String(value).slice(0, 5) : '';
}

function usable(row) {
  if (!row?.date || !row?.location_label) return false;
  if (row.is_open === false) return true;
  return row.is_open === true && formatTime(row.opening_time) && formatTime(row.closing_time);
}

export default function OpeningHours({ className = '', showTitle = true }) {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    let ignore = false;
    loadHours().then((result) => {
      if (!ignore) setRows(result.filter(usable));
    });
    return () => { ignore = true; };
  }, []);

  if (!rows || rows.length === 0) return null;
  const locations = rows.reduce((groups, row) => {
    const key = row.location_key || row.location_label;
    if (!groups[key]) groups[key] = { label: row.location_label, rows: [] };
    groups[key].rows.push(row);
    return groups;
  }, {});

  return (
    <div className={`smoke-opening-hours ${className}`.trim()}>
      {showTitle && <span className="smoke-kicker">Öppettider</span>}
      {Object.entries(locations).map(([key, group]) => (
        <section key={key} aria-label={`Öppettider ${group.label}`}>
          <h3>{group.label}</h3>
          <ul className="smoke-opening-hours-list">
            {group.rows.map((row) => (
              <li key={`${key}-${row.date}`} title={row.source_name || undefined}>
                <span>{formatDate(row.date)}</span>
                <strong>
                  {row.is_open
                    ? `${formatTime(row.opening_time)}–${formatTime(row.closing_time)}`
                    : 'Stängt'}
                </strong>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
}
